import { useLanguage } from "@/contexts/LanguageContext";
import { ScrollReveal } from "@/components/ScrollReveal";
import { VintageMac } from "@/components/VintageMac";

export function SolutionSection() {
  const { t } = useLanguage();

  return (
    <section className="py-32 md:py-40 px-6">
      <div className="max-w-[1400px] mx-auto">
        <ScrollReveal>
          <h2 className="font-display text-display-lg max-w-[20ch]">
            {t("solution.headline")}
          </h2>
        </ScrollReveal>
        <ScrollReveal delay={150}>
          <p className="mt-6 text-body-lg text-muted-foreground max-w-2xl">
            {t("solution.intro")}
          </p>
        </ScrollReveal>

        <ScrollReveal delay={300}>
          <VintageMac />
        </ScrollReveal>
      </div>
    </section>
  );
}
